<template>
    <div></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'quickscan-login',
    components: {},
    data: () => ({}),
    computed: {
        ...mapGetters(['quickscanLoggedIn']),
    },
    methods: {
        ...mapActions(['quickscanLogin']),
    },
    created: function() {
        if (this.quickscanLoggedIn) {
            this.$router.replace({ name: 'quickscan_step1' });
        } else {
            let that = this;
            this.quickscanLogin().then(function() {
                that.$router.replace({ name: 'quickscan_step1' });
            });
        }
    },
};
</script>
